import HeaderEmptyHits from '@/components/header/HeaderEmptyHits';
import HeaderHit from '@/components/header/HeaderHit';
import { AlgoliaSku } from '@/types/algolia';
import { Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useHits } from 'react-instantsearch';

export default function HeaderHits({
  searchOnFocus,
  searchValue,
}: {
  searchOnFocus: boolean;
  searchValue: string;
}) {
  const { items } = useHits<AlgoliaSku>();

  if (items.length === 0) {
    return <HeaderEmptyHits searchOnFocus={searchOnFocus} searchValue={searchValue} />;
  }

  return (
    <Transition
      show={searchOnFocus && items.length > 0 && searchValue?.trim().length > 0}
      enter="tw-transition tw-ease-out tw-duration-200"
      enterFrom="tw-opacity-0 tw-translate-y-1"
      enterTo="tw-opacity-100 tw-translate-y-0"
      leave="tw-transition tw-ease-in tw-duration-150"
      leaveFrom="tw-opacity-100 tw-translate-y-0"
      leaveTo="tw-opacity-0 tw-translate-y-1"
      as={Fragment}
    >
      <div className="tw-mt-1 tw-overflow-hidden tw-rounded-md tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5">
        <ul className="tw-max-h-[600px] tw-list-none tw-divide-y tw-divide-gray-100 tw-overflow-y-auto tw-bg-white tw-py-2 tw-pl-0">
          {[...items]
            .sort((a, b) => a.__position - b.__position)
            .map(item => (
              <HeaderHit key={item.objectID} item={item} />
            ))}
        </ul>
      </div>
    </Transition>
  );
}
